<template lang="pug">
  #home
    .bg-tdays-basic.py-2.txt-white
      .container.cursor-pointer(@click="showSealsModal(['winner','touriDays','trustami'])")
        .row
          .col-12.col-lg-5.text-center.text-lg-left
            .d-inline-flex.align-items-center.h-100.header-point
              font-awesome-icon.mr-2(style="height:1.3em" icon="check")
              span Geprüfter Testsieger seit 2018
          .col-12.col-lg-2.text-center.px-0
            .d-inline-flex.align-items-center.h-100.header-point
              font-awesome-icon.mr-2(style="height:1.3em" icon="check")
              span 100% Käuferschutz
          .col-12.col-lg-5.text-center.text-lg-right
            .d-inline-flex.align-items-center.h-100.header-point(v-if="trustamiVotes")
              font-awesome-icon.mr-2(style="height:1.3em" icon="check")
              span Mehr als {{trustamiVotes}} positive Bewertungen
    HomeHero
    .container.position-relative.pb-2
      AnniversaryHomeHeader
    .container.position-relative.pb-2
      HomeCategories
    ContainerHeadline.my-4
      h2.h1 Highlights der Woche
    ObserveComponent(@observe="observeHighlights")
      .container.my-5
        LiveShoppingItem
        TippsCarousel(:tipps-hosts="tippsHosts")
    ContainerHeadline.my-4
      h2.h1 Ausgezeichneter Urlaub vom Testsieger
    .container.my-5
      Awards(:is-mobile-app-running="isMobileAppRunning")
      ContainerHeadline.my-5
        h3.h2.text-center.my-4 Mehr als {{trustamiVotes}} positive Bewertungen
      TPWidgetCarousel
      // CustomerFeedback(:is-mobile-app-running="isMobileAppRunning")
    ContainerHeadline.my-4
      h2.h1 Gastgeber
    LogoCarousel.position-relative(style="z-index:1")
    BecomeAHost.bg-page
    Seo(:isMobileAppRunning="isMobileAppRunning")
</template>

<script>
/*
import MainCarousel from "./partials/main-carousel/MainCarousel";
import LogoCarousel from "./partials/logo-carousel/LogoCarousel";
import LiveShoppingItem from "./partials/live-shopping/live-shopping-item";

import MainCategories from "./partials/main-categories/MainCategories";
import BecomeAHost from "./partials/become-a-host/BecomeAHost";
import Seo from "./partials/seo/Seo";
 */
import EventBus from "@/event-bus";
import { WebTemplatesEnum } from "@/utils/WebTemplatesEnum.ts";
import { clamp } from "@/lib/helper/math";
import HomeHero from "@/views/home/partials/hero/HomeHero";
import HomeHighlightTabs from "@/views/home/partials/highlightTabs/HomeHighlightTabs";
import TippsCarousel from "@/views/home/partials/tipps/TippsCarousel";
import LiveShoppingItem from "@/views/home/partials/live-shopping/live-shopping-item";
import Awards from "./partials/awards/Awards";
import GridListing from "@/views/components/host/listing/GridListing";
import HomeCategories from "@/views/home/partials/homeCategories/HomeCategories";
import ContainerHeadline from "@/views/components/partials/ContainerHeadline";
import ObserveComponent from "@/views/components/ObserveComponent";
// import CustomerFeedback from "@/views/home/partials/customer-feedback/CustomerFeedback";
import LogoCarousel from "@/views/home/partials/logo-carousel/LogoCarousel";
import BecomeAHost from "@/views/home/partials/become-a-host/BecomeAHost";
import Seo from "@/views/home/partials/seo/Seo";
import mainData from "@/store/main.json";
import { showSealsModal } from "@/lib/components/sealsModal";
import { Hosts } from "@/graphql/Hosts.ts";
import { sendViewItemList } from "@/lib/helper/gtm";
import TPWidgetCarousel from "./partials/trustpilot/TP-WidgetCarousel.vue";
import AnniversaryHomeHeader from "@/views/static/anniversary/partials/AnniversaryHomeHeader.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  components: {
    AnniversaryHomeHeader,
    TPWidgetCarousel,
    Seo,
    BecomeAHost,
    LogoCarousel,
    // CustomerFeedback,
    ObserveComponent,
    HomeCategories,
    GridListing,
    LiveShoppingItem,
    HomeHighlightTabs,
    HomeHero,
    TippsCarousel,
    Awards,
    ContainerHeadline
  },
  setup() {
    return { clamp, trustamiVotes: mainData?.main?.trustamiVotes };
  },
  data() {
    return {
      isMobileAppRunning: false,
      runNumberTicker: false,
      searchValue: "",
      scrollPosition: 0,
      trackScroll: true,
      highlightItem: undefined,
      hasLoadedTippsItems: false,
      tippsHosts: [],
      tippsItems: [],
      hasObservedHighlights: false
    };
  },
  methods: {
    showSealsModal,
    observeHighlights(entry) {
      if (
        !entry.isIntersecting ||
        this.hasObservedHighlights ||
        !this.hasLoadedTippsItems ||
        !this.highlightItem
      )
        return;
      sendViewItemList(this.tippsItems, {
        item_list_id: "home_tipps_of_the_week",
        item_list_name: "Tipps of the Week Homepage"
      });
      this.hasObservedHighlights = true;
    }
  },
  mounted() {
    if (window) window.scrollTo(0, 0);
    EventBus.$emit("changeWebTemplateType", WebTemplatesEnum.Default);
  },
  apollo: {
    tippsHosts: {
      query: Hosts.Queries.TippsHosts,
      loadingKey: "loading",
      error(e) {
        console.log(e);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header-point {
  span {
    width: max-content;
    white-space: nowrap;
    text-align: left;
  }
}
</style>
